import React from 'react';

const HomeModule = () => <div />;
export default HomeModule;
